import { render } from "./UnitedSlider.vue?vue&type=template&id=31a8a147"
import script from "./UnitedSlider.vue?vue&type=script&lang=js"
export * from "./UnitedSlider.vue?vue&type=script&lang=js"

import "./UnitedSlider.vue?vue&type=style&index=0&id=31a8a147&lang=css"
script.render = render

export default script